import MessageContent from './messageContent';
import { ChatBubble } from './styled';
import { ChatMessage, DisplayContext } from './types';

interface MessageRenderingMetadata {
    isMessageSent: boolean;
    hasMultimodalContent: boolean;
    multimodalParts: any[];
    hasText: boolean;
    hasMedia: boolean;
    validMedia: any[];
    totalBubbles: number;
}

interface MessageContentRendererProps {
    message: ChatMessage;
    context?: DisplayContext;
    metadata: MessageRenderingMetadata;
    isCurrentUser: boolean;
    role?: string;
}

const MessageContentRenderer = ({
    message,
    context,
    metadata,
    isCurrentUser,
    role,
}: MessageContentRendererProps) => {
    const {
        isMessageSent,
        hasMultimodalContent,
        hasText,
        hasMedia,
        totalBubbles,
    } = metadata;

    // New behavior: render multimodal content parts
    if (isMessageSent && hasMultimodalContent) {
        return (
            <MessageContent
                message={message}
                context={context}
                renderMultimodal
                isCurrentUser={isCurrentUser}
                role={role}
            />
        );
    }

    // Legacy behavior: render text and media separately
    if (isMessageSent && (hasText || hasMedia)) {
        return (
            <>
                {hasText && (
                    <ChatBubble
                        role={role}
                        isCurrentUser={isCurrentUser}
                        isFirst
                        isLast={!hasMedia}
                        isIntermediate={false}
                    >
                        <MessageContent
                            message={message}
                            context={context}
                            renderContentOnly
                        />
                    </ChatBubble>
                )}
                {hasMedia && (
                    <MessageContent
                        message={message}
                        context={context}
                        renderMediaOnly
                        totalBubbles={totalBubbles}
                        contentBubbleIndex={hasText ? 0 : -1}
                        isCurrentUser={isCurrentUser}
                        role={role}
                    />
                )}
            </>
        );
    }

    // Default rendering for non-message-sent types
    return (
        <ChatBubble
            role={role}
            isCurrentUser={isCurrentUser}
            isFirst
            isLast
            isIntermediate={false}
        >
            <MessageContent
                message={message}
                context={context}
            />
        </ChatBubble>
    );
};

export default MessageContentRenderer;
